import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import { meetingRoomsSearchFields } from '../utils/searchFields';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import {possibleStatus} from '../../../baseApp/shared/components/table/cells/StatusBarCell';
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';

const MeetingRoomsPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    data = [],
    entityList,
    onRowClick,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
}) => {
    const columns = [{
        Header: I18n.t("meetingRooms.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.list.email"),
        accessor: "email",
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.list.parent"),
        id: "parent",
        sortable: true,
        accessor: meetingRoom => meetingRoom.parent? meetingRoom.parent.name : "- - -",
    }, {
        Header: I18n.t("meetingRooms.list.capacity"),
        accessor: "capacity",
        sortable: true
    }, {
        Header: I18n.t("meetingRooms.list.operationTimeStart"),
        accessor: "operationTimeStart"
    }, {
        Header: I18n.t("meetingRooms.list.operationTimeEnd"),
        accessor: "operationTimeEnd"
    }];

    return <div className="page_background">
        <SearchForm
            content={meetingRoomsSearchFields(searchFieldsValues, entityList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.ENTITY}
        />
        <DataTable
            //State dependent
            data={data}
            onRowClick={onRowClick}

            //Pagination
            pages={pages}
            selectedPage={currentPage}
            pageSize={pageSize}
            sortDirection={direction}
            sortProperty={property}
            totalElements={totalElements}
            pageSizeOptions={[10, 20, 50]}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onSortChanged={handleSortChanged}

            //State independent / Configuration
            columns={columns}
            hasStatusBar={true}
            statusBarAccessor={meetingRoom => {
                switch (meetingRoom.status) {
                    case "ENABLED":
                        return possibleStatus.active;
                    case "DISABLED": 
                        return possibleStatus.inactive;
                    case "DISCONNECTED":
                        return possibleStatus.disconnected;
                    default:
                        return possibleStatus.uncertain;
                }
            }}
        />
    </div>
};

MeetingRoomsPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
};

export default MeetingRoomsPage;